/* eslint-disable import/no-cycle */
import { call, put, takeEvery } from 'redux-saga/effects';
import { stock } from '../../../api/api';
import logger from '../../../utils/logger';
import {
  displaySuccess,
  displayLoading,
  displayError
} from '../../../utils/toast/Toast';

import {
  GET_REQUIRED_ATTRIBUTES,
  GET_REQUIRED_ATTRIBUTES_SUCCESS,
  GET_REQUIRED_ATTRIBUTES_FAILURE,
  GET_BARCODE_VALUES,
  GET_BARCODE_VALUES_SUCCESS,
  GET_BARCODE_VALUES_FAILURE,
  HANDLE_LOADER,
  CREATE_STOCK_BATCH,
  CREATE_STOCK_BATCH_SUCCESS
} from './actions';

/**
 * Récupération des attributs pouvant être scannés
 */
export function* getRequiredAttributes() {
  try {
    const response = yield call(stock.getRequiredAttributes);
    yield put({
      type: GET_REQUIRED_ATTRIBUTES_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    logger(error);
    yield put({ type: GET_REQUIRED_ATTRIBUTES_FAILURE });
  }
}

/**
 * Récupération des valeur de code bar du stock
 */
export function* getBarCodeValues() {
  try {
    const response = yield call(stock.getProductBarcode);
    yield put({
      type: GET_BARCODE_VALUES_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    logger(error);
    yield put({ type: GET_BARCODE_VALUES_FAILURE });
  }
}

/**
 * Récupération des valeurs de code bar du stock
 */
export function* createProductBatch(action) {
  const closeLoading = displayLoading(`Création des commandes en cours`);
  yield put({ type: HANDLE_LOADER, data: true });
  try {
    const response = yield call(stock.createProductBatch, action.payload);
    if (response.data.success === true) {
      displaySuccess('Produits importées avec succès');
      yield put({ type: CREATE_STOCK_BATCH_SUCCESS, data: response.data });
    } else {
      displayError("Erreur lors de l'import de produits");
    }
  } catch (error) {
    logger(error);
  } finally {
    yield put({ type: HANDLE_LOADER, data: false });
    closeLoading();
  }
}

const importProductsSaga = [
  takeEvery(CREATE_STOCK_BATCH, createProductBatch),
  takeEvery(GET_REQUIRED_ATTRIBUTES, getRequiredAttributes),
  takeEvery(GET_BARCODE_VALUES, getBarCodeValues)
];

export default importProductsSaga;
